import React from 'react';

const Policies = () => {
  return (
    <div className="bg-white pt-32 pb-20">
      {/* Hero */}
      <section className="section-padding px-6 bg-vainilla">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-serif text-5xl md:text-7xl font-bold text-stone-900 mb-6">
            POLICIES
          </h1>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
            Terms of service, privacy policy, and other legal information.
          </p>
        </div>
      </section>

      {/* Privacy Policy */}
      <section className="section-padding px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl font-bold text-stone-900 mb-8">Privacy Policy</h2>
          <div className="prose prose-stone max-w-none space-y-6">
            <p className="text-stone-600 leading-relaxed">
              Last updated: January 2025
            </p>
            <p className="text-stone-600 leading-relaxed">
              Margaret Nunez ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">Information We Collect</h3>
            <p className="text-stone-600 leading-relaxed">
              We may collect personal information that you voluntarily provide when you contact us, subscribe to our newsletter, or make a purchase. This may include your name, email address, and any other information you choose to provide.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">How We Use Your Information</h3>
            <p className="text-stone-600 leading-relaxed">
              We use the information we collect to respond to your inquiries, send you updates and marketing communications (with your consent), improve our website and services, and process transactions.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">Contact Us</h3>
            <p className="text-stone-600 leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at hello@margaretnunez.com.
            </p>
          </div>
        </div>
      </section>

      {/* Terms of Service */}
      <section className="section-padding px-6 bg-vainilla">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl font-bold text-stone-900 mb-8">Terms of Service</h2>
          <div className="prose prose-stone max-w-none space-y-6">
            <p className="text-stone-600 leading-relaxed">
              Last updated: January 2025
            </p>
            <p className="text-stone-600 leading-relaxed">
              By accessing and using this website, you accept and agree to be bound by the terms and provisions of this agreement.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">Intellectual Property</h3>
            <p className="text-stone-600 leading-relaxed">
              All content on this website, including text, graphics, logos, images, and software, is the property of Margaret Nunez and is protected by intellectual property laws.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">Digital Products</h3>
            <p className="text-stone-600 leading-relaxed">
              All digital products sold through this website are for personal use only. Redistribution, resale, or sharing of purchased products is strictly prohibited.
            </p>
            
            <h3 className="font-serif text-xl font-bold text-stone-900 mt-8 mb-4">Limitation of Liability</h3>
            <p className="text-stone-600 leading-relaxed">
              Margaret Nunez shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of this website or any products purchased through it.
            </p>
          </div>
        </div>
      </section>

      {/* Refund Policy */}
      <section className="section-padding px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-serif text-3xl font-bold text-stone-900 mb-8">Refund Policy</h2>
          <div className="prose prose-stone max-w-none space-y-6">
            <p className="text-stone-600 leading-relaxed">
              Due to the digital nature of our products, all sales are final. However, if you experience technical issues accessing your purchase, please contact us within 7 days and we will work to resolve the issue.
            </p>
            <p className="text-stone-600 leading-relaxed">
              For consulting and event services, cancellation and refund policies are outlined in individual service agreements.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;
